export const InfoCircleIcon = ({
  strokeColor = "var(--color-yellow)",
  width = "22",
  height = "22",
  ...props
}: any) => (
  <svg {...props} width={width} height={height} viewBox="0 0 22 22" fill="none">
    <g id="vuesax/linear/info-circle">
      <g id="info-circle">
        <path
          id="Vector"
          d="M10.9999 20.1666C16.0416 20.1666 20.1666 16.0416 20.1666 10.9999C20.1666 5.95825 16.0416 1.83325 10.9999 1.83325C5.95825 1.83325 1.83325 5.95825 1.83325 10.9999C1.83325 16.0416 5.95825 20.1666 10.9999 20.1666Z"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M11 7.33325V11.9166"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M10.9949 14.6667H11.0031"
          stroke={strokeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);
